/* Pocket Factory · the card's purpose, what a tap opens (PU-1, Andy Oct 25: one PurposeState, one setter).
   The state is the product form's checked properties[Card purpose] radio (snippets/pocket-purpose-selector.liquid), so
   the order line, the form's own saving and a reload read the same thing. This file is the only code that reads or
   sets it: every other script asks here.
   - get(scope): the purpose, '' while none is chosen (scope: another product form; the page's own by default).
   - set(value, {chosen, scope, silent}): checks its radio and says so with one bubbling change (chosen rides on it as
     pfChosen, as a tap of theirs does: a chip, their words). silent checks it with no change, as a page renders its own
     card type (a landing link's ?focus=, pocket.js): nothing counts it as picked, analytics' pf_purpose_selected
     included. false when there is no such purpose here or it is off.
   - is(node): the node is one of the purpose's radios (for a listener of every change on the form).
   - radios(scope): the purpose's radios, for a listener of each one's own change (analytics).
   - picked() / remember(flag): whether the shopper chose it themselves (a tap, or set(…, {chosen})), and that flag
     brought back with a saved form, so the store's own suggestion never replaces their choice. */
(function(root){
  'use strict';
  if(!root.document||root.PocketPurpose)return;
  const doc=root.document,NAME='properties[Card purpose]';
  const form=()=>doc.querySelector('[data-pocket-product] form.product-form');
  const radios=(scope=form())=>[...(scope?.querySelectorAll(`[name="${NAME}"]`)||[])];
  let picked=false;
  const is=node=>!!node&&node.nodeType===1&&node.getAttribute?.('name')===NAME&&!!node.closest?.('form.product-form');
  function get(scope){return radios(scope).find(n=>n.checked)?.value||'';}
  function set(value,{chosen=null,scope,silent=false}={}){
    const input=radios(scope).find(n=>n.value===value);if(!input||input.disabled)return false;
    if(!input.checked){input.checked=true;if(!silent){const event=new root.Event('change',{bubbles:true});if(chosen)event.pfChosen=chosen;input.dispatchEvent(event);}}
    return true;
  }
  // Seen before any other listener of the same change (capture, on the document, from the first script that runs),
  // so every listener reads the flag as it now is.
  doc.addEventListener('change',event=>{if(is(event.target)&&(event.isTrusted||event.pfChosen))picked=true;},true);
  root.PocketPurpose={get,set,is,radios,picked:()=>picked,remember(flag){if(flag===true)picked=true;}};
})(typeof window!=='undefined'?window:globalThis);
